function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "shutdown_svg__a",
  d: "M13.333 0h-2.666v13.333h2.666V0zm6.438 2.896L17.88 4.788A9.234 9.234 0 0121.335 12 9.328 9.328 0 0112 21.335 9.328 9.328 0 012.665 12a9.307 9.307 0 013.439-7.229l-1.88-1.88C1.637 5.093 0 8.347 0 12c0 6.629 5.371 12 12 12s12-5.371 12-12c0-3.652-1.638-6.906-4.229-9.104z"
}));

var _ref2 = /*#__PURE__*/React.createElement("use", {
  fill: "currentColor",
  xlinkHref: "#shutdown_svg__a"
});

function SvgShutdown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 24 24"
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB2aWV3Qm94PSIwIDAgMjQgMjQiPjxkZWZzPjxwYXRoIGlkPSJhIiBkPSJNMTMuMzMzIDBoLTIuNjY2djEzLjMzM2gyLjY2NlYwem02LjQzOCAyLjg5NkwxNy44OCA0Ljc4OEE5LjIzNCA5LjIzNCAwIDAxMjEuMzM1IDEyIDkuMzI4IDkuMzI4IDAgMDExMiAyMS4zMzUgOS4zMjggOS4zMjggMCAwMTIuNjY1IDEyYTkuMzA3IDkuMzA3IDAgMDEzLjQzOS03LjIyOWwtMS44OC0xLjg4QzEuNjM3IDUuMDkzIDAgOC4zNDcgMCAxMmMwIDYuNjI5IDUuMzcxIDEyIDEyIDEyczEyLTUuMzcxIDEyLTEyYzAtMy42NTItMS42MzgtNi45MDYtNC4yMjktOS4xMDR6Ii8+PC9kZWZzPjx1c2UgZmlsbD0iY3VycmVudENvbG9yIiB4bGluazpocmVmPSIjYSIvPjwvc3ZnPgo=";
export { SvgShutdown as ReactComponent };